import { EventEmitter } from "events";

class WorkEvent extends EventEmitter {}

export default new WorkEvent();
